<template>
  <div>
    <template v-if="showForm">
      <IdentityChoice
        v-show="step === 'choice'"
        v-model:id="id"
        :radio-options="radioOptions"
      />
      <IdentityDetails
        v-show="step === 'details'"
        :id="id"
        :form-id="formId"
        :ids="ids"
        :label="label"
        :show-form="showForm"
        @submit="handleSubmit"
      />
    </template>
    <p v-else class="text-static-default-low body-1 mb-3 mt-4">
      {{ i18n(translations.alreadySentTitle) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import {
  ID_DOCUMENTS,
  type IdDocumentsType,
  KYC_IDS,
  useBuybackConfig,
} from '@backmarket/nuxt-layer-buyback/composables/config/useBuybackConfig'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { type FormValues } from '~/scopes/buyback/components/FormGenerator/FormGenerator.vue'

import translations from './Identity.translations'
import IdentityChoice from './IdentityChoice.vue'
import IdentityDetails from './IdentityDetails.vue'

defineProps<{
  showForm: boolean
  formId: string
  step: 'choice' | 'details'
}>()
const emit = defineEmits<{
  submit: [values: FormValues, type: IdDocumentsType]
}>()
const { kyc } = useBuybackConfig()
const i18n = useI18n()

const OPTIONS_TITLES = {
  [ID_DOCUMENTS.PASSPORT]: translations.passport,
  [ID_DOCUMENTS.DRIVING_LICENCE]: translations.drivingLicence,
  [ID_DOCUMENTS.ID_CARD]: translations.idCard,
}

const radioOptions = computed(() => {
  const { list } = kyc[KYC_IDS.IDENTITY]

  return list.map(({ isOneSide, type }) => {
    return {
      id: type,
      label: i18n(OPTIONS_TITLES[type]),
      isOneSide,
    }
  })
})
const id = ref<IdDocumentsType>(radioOptions.value[0].id)
const ids = radioOptions.value.map((option) => option.id)
const label = computed(
  () =>
    radioOptions.value.find((option) => option.id === id.value)?.label || '',
)

function handleSubmit(values: FormValues) {
  emit('submit', values, id.value)
}
</script>
